/**
 * @module: KR下任务
 * @author: yuanxm
 * @date: 2020-05-16 11:07:34
 */
import { observable, action } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import { IOssFile } from '@src/utils/upload';
import { Toast } from 'antd-mobile';

class OKR {
  // 附件
  @observable
  attachmentList: IOssFile[] = [];
  // 参与者
  @observable
  followerList: any[] = [];
  // 创建任务状态
  @observable
  createFetching: string = 'init';

  @action.bound
  async createTask(params: any) {
    this.createFetching = 'pending';
    const res = await ajax.post('/company/api/tasks', params);
    this.createFetching = 'done';
    if (+res.error_code !== 0) {
      Toast.fail(res.msg, 1);
    } else {
      if (params.is_okr) {
        window.AnalysysAgent &&
          window.AnalysysAgent.track('btn_qyb_okr_cjrenwu', {
            $title: 'OKR-创建任务',
            btn_name: '创建任务'
          });
      } else {
        window.AnalysysAgent &&
          window.AnalysysAgent.track('btn_qyb_renwu_cjrenwu', {
            $title: '任务协作-创建任务',
            btn_name: '创建任务'
          });
      }
    }
    return res;
  }
}

export default OKR;
